@if (display) {
  <p-dialog [draggable]="true" [(visible)]="display"
    [transitionOptions]="'150ms cubic-bezier(0, 0, 0.2, 1)'" [modal]="true" (onHide)="close($event)" (visibleChange)="!$event && close($event)"
    styleClass="pDialog" >
    <ng-template pTemplate="header">
      <div style="width: 100%; text-align: center; font-weight: 600; color: #C42C22;">{{ isNew ? ('zones.zone-form.create' | translate) : ('zones.zone-form.update' | translate) }}</div>
    </ng-template>
    <div class="container-fluid m-0 p-0" style="margin-top: 1rem !important;">
      <!-- <div class="ui-grid-row">
      <div class="ui-grid-col-12">
        @for (msg of messages; track msg) { <p-message [severity]="msg.severity" [text]="msg.detail"></p-message> }
      </div>
    </div> !-->
    <!-- ZONE DATA -->
    <p-panel header={{zoneData}} [toggleable]="true" styleClass="custom-panel">
      <div class="d-flex justify-content-between container px-0">
        <!-- #region COL 1 -->
        <div class="col me-2">
          <!-- #region Name label and textbox -->
          <div class="row mb-2">
            <form-input i18n-fieldName fieldName={{zoneName}} [errors]="errors.name">
              <input pInputText [(ngModel)]="entity.name" [style]="{'width':'250px'}" />
            </form-input>
          </div>
          <!-- #endregion -->
          <!-- #region Zone Group selector -->
          <div class="row mb-2">
            <form-input [required]="true" i18n-fieldName fieldName={{zoneGroupLabel}} [errors]="errors.zoneGroup">
              <!-- <p-select id="dropdownZoneGroups" (onChange)="zoneGroupChanged()" placeholder={{zonePlaceholder}}
              [options]="availableZoneGroups" [(ngModel)]="entity.zoneGroup.id" [style]="{'width':'100%'}"
            filter="filter" dataKey="id" optionLabel ="label"></p-select>  -->
            <p-select id="dropdownZoneGroups" (onChange)="zoneGroupChanged()" placeholder={{zonePlaceholder}}
              [options]="availableZoneGroups" [(ngModel)]="selectedPreconfig2" [style]="{'width':'100%'}"
            filter="filter" dataKey="value" optionLabel ="label" appendTo="body"></p-select>
            <button class="AddButton" type="button" pButton icon="fa fa-plus" (click)="createZoneGroup()"
            i18n-pTooltip pTooltip="{{'zones.addNewZoneGroup' | translate}}" tooltipPosition="top"></button>
          </form-input>
        </div>
        <!-- #endregion -->
        <!-- #region Enabled label and checkbox -->
        <div class="row mb-2">
          @if (!isRealtime) {
            <form-input i18n-fieldName fieldName={{enabledLabel}} [errors]="errors.enabled">
              <p-checkbox disabled="true" [(ngModel)]="entity.enabled" binary="true"></p-checkbox>
            </form-input>
          }
        </div>
        <!-- #endregion -->
      </div>
      <!-- #endregion -->
      <div class="vr"></div>
      <!-- #region COL 2 -->
      @if (!plannerzone) {
        <div class="col ms-2">
          <!-- #region Type of the zone label and selector -->
          <div class="row mb-2">
            <form-input i18n-fieldName fieldName={{zoneType}} [errors]="errors.circular">
              <p-select [options]="Types" [(ngModel)]="entity.circular" (onChange)="fireZoneTypeChangedEvent($event)"
              [disabled]="disableZoneTypeSelector" [style]="{'width':'250px'}"></p-select>
            </form-input>
          </div>
          <!-- #endregion -->
          <!-- #region Events label and cehckboxes with its labels -->
          <div class="row mb-2">
            <div class="d-flex flex-row">
              <div class="col mr-2">
                <form-input fieldName={{eventsLabel}}></form-input>
              </div>
              <form-input fieldName="" [errors]="errors.eventOnEnter" class="ml-3">
                <div class="d-flex align-items-center gap-2">
                  <p-checkbox inputId="eventOnEnter" binary="true"
                  [(ngModel)]="entity.eventOnEnter"></p-checkbox>
                  <label for="eventOnEnter">{{enterLabel}}</label>
                </div>
              </form-input>
              <form-input fieldName="" [errors]="errors.eventOnLeave" class="ml-3">
                <div class="d-flex align-items-center gap-2">
                  <p-checkbox inputId="eventOnLeave" binary="true"
                  [(ngModel)]="entity.eventOnLeave"></p-checkbox>
                  <label for="eventOnLeave">{{leaveLabel}}</label>
                </div>
              </form-input>
            </div>
          </div>
          <!-- #endregion -->
          <!-- #region CUSTOM ZONE POINTS TEXTBOX -->
          <div class="d-flex row">
            @if (user.isAdmin) {
              <form-input i18n-fieldName fieldName={{customPoints}} [errors]="errors.name">
                <input type="text" [ngModel]="zoneStr" (ngModelChange)="zoneStringChanged($event)">
              </form-input>
            }
          </div>
          <!-- #endregion -->
        </div>
      }
      @if (plannerzone) {
        <div class="col ms-2">
          <div class="row  mb-2" style="display: flex; align-items: center;">
            <div class="form-group">
              <label class="form-label">{{ zoneroutes }}</label>
              <p-multiSelect styleClass="custom-multiselect" [style]="{'min-width':'300px'}" [filter]="true"
                [(ngModel)]="selectedRoutes" optionLabel="name" [options]="availableRoutes"
                filterBy="name" placeholder="{{zoneroutes}}" appendTo="body" dataKey="id"
                (onFocus)="onMultiSelectFocus(selectedRoutes, availableRoutes)">
                <ng-template style="width: 100%;" pTemplate="selectedItems">
                  <span>
                    {{ selectedRoutes && selectedRoutes.length ? selectedRoutes.length + ' ' + zonerouteselected  : NoRoutes }}
                  </span>
                </ng-template>
                <ng-template let-option pTemplate="item">
                  <div class="p-multiselect-representative-option">
                    {{ (option?.name || '') }}
                  </div>
                </ng-template>
              </p-multiSelect>
            </div>
          </div>
          <div class="row  mb-2" style="display: flex; align-items: center;">
            <div class="form-group">
              <label class="form-label">{{zonedrivers}}</label>
              <p-multiSelect styleClass="custom-multiselect" [style]="{'min-width':'300px'}" [filter]="true"
                [(ngModel)]="selectedUsers" optionLabel="name" [options]="availableUsers"
                filterBy="name,surname1, surname2" placeholder="{{zonedrivers}}" appendTo='body' dataKey="id"
                (onFocus)="onMultiSelectFocus(selectedUsers, availableUsers)" >
                <ng-template style="width: 100%;" pTemplate="selectedItems">
                  <span>
                    {{ selectedUsers && selectedUsers.length ? selectedUsers.length + ' ' + driverselected  : nodriver }}
                  </span>
                </ng-template>
                <ng-template let-option pTemplate="item">
                  <div class="p-multiselect-representative-option">
                    {{ (option?.name || '') + ' ' + (option?.surname1 || '') + ' ' +
                  (option?.surname2 || '') }} </div>
                </ng-template>
              </p-multiSelect>
            </div>
          </div>
          <!-- #endregion -->
        </div>
      }
    </div>
  </p-panel>
  <!--class="mt-3"-->
  @if (showMap) {
    <div >
      <app-custom-map #map mapId="map-zones" [display]="display" [options]="customMapOptions" [zones]="zones"
        (eventCreateZone)="notifyCreateZone($event)" (eventUpdateZone)="notifyUpdatePOI($event)"
      (loadMap)="initMapAfterViewInit($event)" ></app-custom-map>
    <!--    style="flex-shrink:0;width:100%;max-width:100%; padding-right:calc(var(--bs-gutter-x)*0.5); padding-left:calc(var(--bs-gutter-x)*0.5);margin-top:var(--bs-gutter-y);-->
    </div>
}

  </div>

  <ng-template pTemplate="footer">
    <div style="padding: 0.5rem 0;">
    <!-- Permissions -->
    @if (isNew) {
      <div class="d-flex justify-content-center">
        <button type="button" class="btn custom-button" (click)="saveZonesForm()">
          <i class="fa fa-check"></i> {{saveButton}}
        </button>
      </div>
    }
    @if (isNew === false) {
      <div class="d-flex justify-content-end gap-2">
        @if (entity._$update) {
          <button type="button" class="btn custom-button" (click)="saveZonesForm()">
            <i class="fa fa-check"></i> {{saveButton}}
          </button>
        }
        @if (entity._$update === false) {
          <div style="display: inline-block;" i18n-pTooltip pTooltip="{{'general.noPermissionsUpdate' | translate}}" tooltipPosition="top">
            <button disabled type="button" class="btn custom-button">
              <i class="fa fa-check"></i> {{saveButton}}
            </button>
          </div>
        }
        @if (entity._$update) {
          <button type="button" class="btn custom-button" (click)="changeStatus(!entity.enabled)">
            <i class="fa fa-check"></i> Change status
          </button>
        }
      </div>
    }
    </div>
</ng-template>
</p-dialog>
}

<app-zone-group-form [realTime]=true></app-zone-group-form>

<p-confirmDialog i18n-header header="{{'general.confirmation' | translate}}" icon="fa fa-question-circle" width="425"></p-confirmDialog>